export interface FilterOption {
  label: string;
  value: string;
}

export const getUniqueOptions = <T, K extends keyof T>(items: T[], key: K): FilterOption[] => {
  const uniqueValues = Array.from(new Set(items.map(item => String(item[key] || '')).filter(Boolean)));
  return uniqueValues.sort().map(value => ({
    label: value,
    value: value
  }));
};

export const filterItems = <T>(
  items: T[],
  searchQuery: string,
  searchFields: (keyof T)[],
  filters: Record<string, any>
): T[] => {
  return items.filter(item => {
    // Text Search
    const matchesSearch = searchQuery === '' || searchFields.some(field => {
      const value = item[field];
      return String(value).toLowerCase().includes(searchQuery.toLowerCase());
    });

    // Exact Filters
    const matchesFilters = Object.entries(filters).every(([key, filterValue]) => {
      if (!filterValue) return true;
      return String(item[key as keyof T]) === filterValue;
    });

    return matchesSearch && matchesFilters;
  });
};
